import {
    useCallback, useEffect, useReducer,
} from 'react';

interface State {
    clientName: string;
    clientAge?: number;
    risk: string;
    [key: string]: unknown;
}

type Action = { type: 'setData'; payload: Partial<State> };

const initialState: State = {
    clientName: '',
    clientAge: undefined,
    risk: '',
};

export const CHANGE_STRATEGY_CACHE_KEY = 'change_strategy';

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'setData':
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export const useStrategy = ({ portfolioId }: { portfolioId?: number | string }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const setData = useCallback((lData: Partial<State>) => {
        const storageKey = `${CHANGE_STRATEGY_CACHE_KEY}_${portfolioId || ''}`;
        const prevStrategyData = JSON.parse(sessionStorage.getItem(storageKey) || '{}');

        sessionStorage.setItem(storageKey, JSON.stringify({ ...prevStrategyData, ...lData }));
        dispatch({ type: 'setData', payload: lData });
    }, [portfolioId]);

    const removeData = useCallback(() => {
        const storageKey = `${CHANGE_STRATEGY_CACHE_KEY}_${portfolioId || ''}`;

        sessionStorage.removeItem(storageKey);
        dispatch({ type: 'setData', payload: {} });
    }, [portfolioId]);

    useEffect(() => {
        const storageKey = `${CHANGE_STRATEGY_CACHE_KEY}_${portfolioId || ''}`;
        const cachedNewStrategyData = JSON.parse(sessionStorage.getItem(storageKey) || 'null');

        if (cachedNewStrategyData) {
            dispatch({ type: 'setData', payload: cachedNewStrategyData });
        }
    }, [portfolioId]);

    return {
        data: state,
        setData,
        removeData,
    };
};
